import { createI18n  } from 'vue-i18n/dist/vue-i18n.cjs'

const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)

const availableLocales = locales.keys().map(entry => entry.substr(2, 2).toLowerCase())

function _loadLocaleMessages (clientLocales) {
    const messages = {}
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            // date picker locale, import in accordance to selected locale
            // require(`vue2-datepicker/locale/${locale}`)
            messages[locale] = locales(key)
        }
    })

    // Kunden-Sprachdatei überschreibt die Sprach-Einträge im messages-Array(z.B. de wird von de_VVSFlisl.json überschrieben)
    if  (clientLocales) {
        clientLocales.forEach(locale => {
            let localeKey = Object.keys(locale)[0]

            if(messages[localeKey]) {
                for (const key in messages[localeKey]) {
                    if(Object.values(locale)[0][key]) {
                        messages[localeKey][key] = _mergeRecursive(messages[localeKey][key], Object.values(locale)[0][key])
                    }
                }
            }
        })
    }

    return messages
}

// https://stackoverflow.com/questions/171251/how-can-i-merge-properties-of-two-javascript-objects-dynamically
// Recursively merge properties of two objects
function _mergeRecursive(obj1, obj2) {
    for (var p in obj2) {
        try {
            // Property in destination object set update its value.
            if ( obj2[p].constructor==Object ) {
                obj1[p] = _mergeRecursive(obj1[p], obj2[p])
            } else {
                obj1[p] = obj2[p]
            }
        } catch(e) {
            // Property in destination object not set create it and set its value.
            obj1[p] = obj2[p]
        }
    }

    return obj1
}

function _getDefaultLocale() {
    let locale = process.env.VUE_APP_I18N_LOCALE || 'de'

    const browserlocale = navigator.language.substring(0, 2).toLowerCase()

    if (availableLocales.includes(browserlocale)) {
        locale = browserlocale
    }

    return locale
}

export function initI18n(clientLocales) {
    const locale         = _getDefaultLocale()
    const fallbackLocale = process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'de'
    const messages       = _loadLocaleMessages(clientLocales)

    const i18n = createI18n({
        locale,
        fallbackLocale,
        messages
    })

    i18n.availableLocales = availableLocales

    return i18n
}
